exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k8s-tags .k8s-tag-pill:not(:last-child) {\n  margin-right: 8px; }\n", ""]);

// exports
